/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
export interface IPackageListingAppBaseText {
    filtersTitle: string;
    clearAllFiltersButtonText: string;
    productionFilterLabel: string;
    productionFilterDefaultValue: string;
    dayOfWeekFilterLabel: string;
    dayOfWeekFilterDefaultValue: string;
    timeSlotFilterLabel: string;
    timeSlotDefaultValue: string;
    miniCartTitle: string;
    minimumPerformanceRequiredMessage: string;
    addAdditionalPerformancesMessage: string;
    addAdditionalPerformancesForPerformanceGroupMessage: string;
    maxPerformancesMessage: string;
    maxPerformancesForGroupMessage: string;
    removeButtonText: string;
    continueToSeatingButtonText: string;
    reservePackageButtonText: string;
    viewPerformancesButtonText: string;

    packageSubtotalTitle: string;
    selectTicketsTitle: string;
    selectPackageTitle: string;
    missingPriceTypeSelectionMessage: string;
    selectAZoneLabel: string;
    selectAZoneDropdownDefaultValue: string;
    changeZoneButtonText: string;
    synopsisHeaderLabel: string;
    showSynopsisButtonText: string;
    hideSynopsisButtonText: string;

    loadingLabel: string;
    hidePerformancesButtonText: string;
    selectSubscriptionButtonText: string;
    addToCartButtonText: string;
    loadMorePerformancesButtonText: string;

    packageLoadErrorMessage: string;
    performanceUnavailableErrorMessage: string;

    generalPackageProcessingErrorMessage: string;
    packageProcessingMessage: string;

    orderNotesTitle: string;
    orderNotesOptionalText: string;
    orderNotesPlaceholder: string;

    renewalNotesTitle: string;
    seatSelectionDescription: string;

    seatingPreferencesTitle: string;
    seatingPreferencesDefaultText: string;
    seatingPreferenceOptions: Array<string>;

    // Not from api but ~about~ api
    requesting: boolean;
    apiError: any;
}

export const defaultBaseText: IPackageListingAppBaseText = {
    filtersTitle: "Filters",
    selectSubscriptionButtonText: "Select",
    clearAllFiltersButtonText: "Clear all filters",
    productionFilterLabel: "Productions",
    productionFilterDefaultValue: "All Productions",
    dayOfWeekFilterLabel: "Days",
    dayOfWeekFilterDefaultValue: "All Days",
    timeSlotFilterLabel: "Times",
    timeSlotDefaultValue: "All Times",
    miniCartTitle: "Your subscriptions",
    minimumPerformanceRequiredMessage: "Select at least {0} performances",
    addAdditionalPerformancesMessage: "Select at least {0} more performances",
    addAdditionalPerformancesForPerformanceGroupMessage: "Select at least {0} more performances for {1}",
    maxPerformancesMessage: "You've reached the max for this package",
    maxPerformancesForGroupMessage: "You've reached the max for {0}",
    removeButtonText: "Remove",
    continueToSeatingButtonText: "Continue to seating",
    reservePackageButtonText: "Reserve Package",
    packageSubtotalTitle: "Subtotal",
    loadingLabel: "Loading",
    hidePerformancesButtonText: "Hide performances",
    viewPerformancesButtonText: "View performances",
    addToCartButtonText: "Add to cart",
    loadMorePerformancesButtonText: "Load more performances",
    generalPackageProcessingErrorMessage: "There was an error processing your package request. Please contact box office",
    packageLoadErrorMessage: "Error Loading Packages",
    packageProcessingMessage: "Processing",
    performanceUnavailableErrorMessage: "There was an issue with performance {0}. Please pick another performance or try again",
    hideSynopsisButtonText: "Hide Synopsis",
    showSynopsisButtonText: "Read Synopsis",
    synopsisHeaderLabel: "Synopsis",
    selectTicketsTitle: "Select Tickets",
    selectPackageTitle: "Select Number Of Packages",
    seatingPreferencesTitle: "Seating Preferences",
    seatingPreferencesDefaultText: "Choose a preference",
    seatingPreferenceOptions: [],
    missingPriceTypeSelectionMessage: "Please select a price type to continue",
    selectAZoneLabel: "Select a Zone",
    selectAZoneDropdownDefaultValue: "",
    changeZoneButtonText: "Change Zone",
    orderNotesTitle: "Order Notes",
    orderNotesPlaceholder: "500 characters or fewer",
    orderNotesOptionalText: "Optional",
    renewalNotesTitle: "Renewal Notes",
    seatSelectionDescription: "You have reduced your seat quantity to ({0}) seat. Please select the seats you would like to keep:",
    requesting: false,
    apiError: null
}